export default [
  { value: 0, label: "Draft" },
  { value: 1, label: "Pending Approval" },
  { value: 2, label: "Scheduled" },
  { value: 3, label: "Active" },
  { value: 4, label: "Posted" },
  { value: 5, label: "Expired" },
  { value: 6, label: "Inactive" },
  { value: 7, label: "Completed" },
  { value: 8, label: "Archived" },
  { value: 9, label: "Rejected" },
  { value: 10, label: "Deleted" },
  { value: 11, label: "Upcoming" }
];